import React from "react";
import SkillDetails from "./SkillDetails";
import {languages, techAndFrameWorks, databaseAndTools, other} from "../../data/SkillData.js";
import "./Skills.css";

function Skills() {
  return (
    <div className="one-second-animation">
      <h2 className="h2">Skills</h2>
      <div className= "components" id="skills-div">
        <SkillDetails 
          heading="Languages"
          list={languages}
        />
        <SkillDetails 
          heading="Technologies & Frameworks"
          list={techAndFrameWorks}
        />
        <SkillDetails 
          heading="Databases & Tools Used"
          list={databaseAndTools}
        />
        <SkillDetails 
          heading="Other"
          list={other}
        />
      </div>
    </div>
  );
}

export default Skills;